var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-branch-container"
  }, [_vm.props.title ? _c('p', {
    staticClass: "form-card-title"
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")]) : _vm._e(), _vm._l(_vm.props.list, function (item, index) {
    return _c('div', {
      key: index,
      class: _vm.getItemClass(item),
      on: {
        "click": function ($event) {
          return _vm.listItemClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.content) + " ")]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }